import React from 'react';
import styles from '../css/Footer.module.css';

function Footer() {
	return (
		<footer className={styles.footer}>
			<div className={styles.topSection}>
				<div className={styles.logo}>Exporest</div>
				<div className={styles.columns}>
					<div>
						<h4>Product</h4>
						<ul>
							<li>Business Travel</li>
						</ul>
					</div>
					<div>
						<h4>Company</h4>
						<ul>
							<li>About Us</li>
							<li>Affiliates</li>
							<li>Customers</li>
							<li>Careers</li>
							<li>Partners</li>
							<li>Press Room</li>
							<li>Reviews</li>
						</ul>
					</div>
					<div>
						<h4>Popular Topics</h4>
						<ul>
							<li>Bleisure Travel</li>
							<li>Corporate Cards</li>
							<li>Expense Reimbursements</li>
							<li>Travel & Expense Policy</li>
							<li>Team Travel</li>
							<li>Small Business</li>
							<li>Compare us</li>
						</ul>
					</div>
				</div>
			</div>

			<div className={styles.bottomSection}>
				<div className={styles.legalLinks}>
					<a href="#">Website Terms of Use</a>
					<a href="#">Privacy</a>
					<a href="#">Security</a>
					<a href="#">Accessibility Statement</a>
					<a href="#">Status</a>
					<a href="#">Your Privacy Choices</a>
				</div>
				<p className={styles.notice}>
					Address
				</p>
				<p className={styles.copy}>&copy; 2025 Exporest</p>
			</div>
		</footer>
	);
}

export default Footer;
